<template>
    <div class="notice notice-error">
        <div class="icon">
            <img src="/svg/error-icon2.svg" alt="" />
        </div>

        <div class="text">
            {{message}}

            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['message'],
    }
</script>
